import { AuthCredentials, IUser } from '../models/auth.model';
import getService from './getService';
import postService from './postService';
import userService from './user.service';


const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

export const destroyUserSession = () => {
  localStorage.removeItem("tokenId");
  localStorage.removeItem("user");
  localStorage.removeItem('page_no');
  localStorage.clear();
}

export const getLocalUserProfile = (): IUser | null => {

  const user = localStorage.getItem("user");
  const userWalconst = localStorage.getItem("user-wallet");

  if (user) {
    const userModel: IUser = JSON.parse(user);

    return userModel;
  }

  return null;
}

export const getAuthToken = (): string | null => {
  const token = localStorage.getItem('tokenId');
  if (token) {
    
    return token.toString()
  }
  return '';
}

export const getUserWallet = async (uuid: string): Promise<any> => {
  const wallet = await userService.getUserWallet(uuid)
  if (wallet)
    return wallet.data
}


class AuthService {
  async login(data: AuthCredentials) {
    const response = await postService.post(`${CONFIG_API_URL}auth/login`, data);

    return response.data;
  }

  async logout() {
    try{
      const response = await postService.post(`${CONFIG_API_URL}/auth/logout`, {});
  
      localStorage.removeItem("tokenId");
      localStorage.removeItem("user");
      localStorage.removeItem('page_no');

      return response.data;
    }catch(e){
      console.error(e)
    }

  }

  async forgot_password(email: any) {
    const response = await getService.get(`${CONFIG_API_URL}auth/forgot-password/${email}`);

    return response.data;
  }
  async confirmforgotPassword(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}auth/forgot-password`, data);

    return response.data;
  }

  async verifyEmail(token: any) {
    const response = await getService.get(`${CONFIG_API_URL}auth/verify/${token}`);

    return response.data;
  }


}

export default new AuthService();
